module.exports = __webpack_public_path__ + "static/media/lock-icon-with-circle.495132c0.svg";